// src/config/delegatePortal.js

/**
 * PURPOSE: Configuración del enlace saliente "Gestionar elegibles" hacia el portal de delegados de Hayllis 2.0 (FTR-0015).
 * RESPONSIBILITIES: Interruptor apagado por defecto y origen del portal. Es solo navegación: el portal exige su propia
 *   sesión de delegado y el backend decide institución, capacidad y plazo. Este repositorio no usa variables de
 *   entorno (config comprometida en src/config/); encenderlo es un cambio deliberado y un nuevo despliegue.
 * COLLABORATORS: src/utils/delegateEligiblesLink.js, src/components/Programacion/Programacion.jsx.
 */
export const DELEGATE_ELIGIBLES_LINK_ENABLED = false;

// Dominio canónico de Hayllis 2.0 (decisión B-6).
export const HAYLLIS_2_ORIGIN = "https://hayllisports.com";
